import React from 'react';
import classNames from 'classnames';
import { getIsMobile } from '../../../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../../../api-provider';
import RicosPluginToolbarPortal from '../../../portals/ricos-plugin-toolbar-portal';
import { useRemainingWidth } from '../use-remaining-width/use-remaining-width';
import styles from './comment-box-inner-footer.module.scss';
export const CommentBoxInnerFooter = ({ className, publishControls, ricosToolbarId, }) => {
    const isMobile = useApi(getIsMobile);
    const { maxWidth, containerRef, elementRef } = useRemainingWidth();
    return (React.createElement("div", { className: classNames(styles.container, isMobile && styles.isMobile, className), ref: containerRef },
        React.createElement(RicosPluginToolbarPortal, { className: styles.toolbar, toolbarId: ricosToolbarId, ref: elementRef }),
        React.createElement("div", { style: { maxWidth: maxWidth ?? 'auto' } }, publishControls)));
};
//# sourceMappingURL=comment-box-inner-footer.js.map